const COMMENTS = [
  {
    name: '漫迷小Q',
    avatar: 'Q',
    date: '2026.07.28',
    content: '这个韩漫导航真的太方便了！之前每次找韩漫网站都要翻半天，现在直接在这里就能找到韩漫之家、韩漫屋所有入口，追更效率翻倍。',
    platform: '来自 韩漫之家',
  },
  {
    name: '樱花飘落',
    avatar: '樱',
    date: '2026.07.27',
    content: '作为一个刚入坑韩漫的新人，这个韩漫漫画网站大全帮我少走了很多弯路。专题索引分类清晰，免费韩漫网址收录也很全，强烈推荐！',
    platform: '来自 网站留言',
  },
  {
    name: '深夜追漫人',
    avatar: '夜',
    date: '2026.07.26',
    content: '更新动态模块做得很好，每天打开就能看到最新的韩漫在线观看资源。人气榜单也很客观，跟着排行追了好几部宝藏韩漫。',
    platform: '来自 韩漫屋',
  },
  {
    name: '漫画控Leo',
    avatar: 'L',
    date: '2026.07.25',
    content: '韩漫网址大全里居然有这么多我没发现的平台！恋爱韩漫专题精准戳中我的偏好，收藏起来每天必刷。希望持续更新更多韩漫网入口！',
    platform: '来自 韩漫吧',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            读者评论
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            来自韩漫爱好者的真实使用反馈
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 max-w-3xl mx-auto">
          {COMMENTS.map((comment, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-lg p-5 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-sm font-bold flex-shrink-0">
                  {comment.avatar}
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-medium text-foreground-800">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.date}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
              <div className="mt-3 text-xs text-foreground-400">{comment.platform}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}